<div class="stats-page">
  <div class="stats-toolbar">
    <div class="stats-toolbar__copy">
      <p class="stats-kicker">Performance</p>
      <h2 class="stats-title">My Stats</h2>
    </div>

    <mat-form-field
      appearance="outline"
      class="stats-room-field"
      *ngIf="webinarRooms !== undefined && webinarRooms.length > 1">
      <mat-label>Webinar room</mat-label>
      <mat-select
        placeholder="Select webinar room"
        (selectionChange)="GetStatsOfRoom($event)"
        [formControl]="webinarRoomControl">
        <mat-option *ngFor="let webinarRoom of webinarRooms" [value]="webinarRoom.webinarRoomId">
          {{ webinarRoom.roomName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="stats-room-pill" *ngIf="webinarRooms?.length === 1">
      <mat-icon>storefront</mat-icon>
      <span>{{ webinarRooms[0].roomName }}</span>
    </div>
  </div>

  <div *ngIf="inputData !== undefined && inputData.length === 4">
    <div class="stats-section-header">
      <mat-icon>bar_chart</mat-icon>
      <span>Items closed by queue time</span>
    </div>

    <div class="stats-grid">
      <div
        class="stats-card"
        *ngFor="let row of inputData; let i = index"
        [ngClass]="'stats-card--' + slotTone(row.QueueTime, i)">
        <div class="stats-card-header">
          <span class="queue-time-label">Queue time</span>
          <span class="queue-time-value">{{ formatTimeSlot(row.QueueTime) }}</span>
        </div>
        <div class="stats-card-body">
          <div class="stats-metric stats-metric--yesterday">
            <span class="metric-label">Yesterday</span>
            <span class="metric-value">{{ row.Yesterday }}</span>
          </div>
          <div class="stats-metric stats-metric--week">
            <span class="metric-label">This week</span>
            <span class="metric-value">{{ row.Week }}</span>
          </div>
          <div class="stats-metric stats-metric--month">
            <span class="metric-label">This month</span>
            <span class="metric-value">{{ row.Month }}</span>
          </div>
          <div class="stats-metric stats-metric--quarter">
            <span class="metric-label">This quarter</span>
            <span class="metric-value">{{ row.Quater }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
